import * as React from 'react';
import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';
import { GlobalPrivateState, dynamicTitles, dynamicTitlesKey, validateConfiguration, plateBuilder, warnings, isConfigurationDetail, /*configurationPanels*/ } from 'src/api';
import { Switch, Route, Redirect } from 'react-router';
import ConfigurationTroughPage from './ConfigurationTrough/ConfigurationTrough.page';
import ConfigurationBasinDimensionsPage from './ConfigurationBasinDimensions/ConfigurationBasinDimensions.page';
import ConfigurationApronBacksplashPage from './ConfigurationApronBacksplash/ConfigurationApronBacksplash.page';
import ConfigurationRecessesPage from './ConfigurationRecesses/ConfigurationRecesses.page';
import ConfigurationSurfacePage from './ConfigurationSurface/ConfigurationSurface.page';
import ConfigurationAssembliesPage from './ConfigurationAssemblies/ConfigurationAssemblies.page';
import ConfigurationDrainsPage from './ConfigurationDrain/ConfigurationDrain.page';
import ConfigurationProjectPage from './ConfigurationProject/ConfigurationProject.page';
import ConfigurationDelete from '../ConfigurationDelete/ConfigurationDelete.page';
import ConfigurationDuplicate from '../ConfigurationDuplicate/ConfigurationDuplicate.page';
import ConfigurationRename from '../ConfigurationRename/ConfigurationRename.page';
import ConfigurationSwitchViewDetail from 'src/app/Partials/Configuration/SwitchView/ConfigurationSwitchViewDetail';

import { ConfigurationNavigation, ThreeJsPartial } from 'src/app/Partials';

import './ConfigurationDetail.page.scss';
import { ConfigurationDefaultsDispatcher, ConfigurationDispatcher, ValidationDispatcher, TroughDispatcher } from 'src/app/Container';
import CheckoutPage from 'src/app/Pages/Checkout/Checkout.page';
import LoadingSpinner from 'src/app/Partials/LoadingSpinner/LoadingSpinner';
import { Scrollable } from 'src/app/Container';
// import { NavbarToggler } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';
import { SvgView } from 'src/app/Partials/SvgView';
import ConfigurationCountryPage from '../ConfigurationCountry/ConfigurationCountry.page';
import ConfigurationArchive from '../ConfigurationArchive/ConfigurationArchive.page';
import ConfigurationUnarchive from '../ConfigurationUnarchive/ConfigurationUnarchive.page';
import ConfigurationDownload3D from 'src/app/Partials/Configuration/Utils/ConfigurationDownload3D';

export interface ConfigurationDetailPageProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: GlobalPrivateState['configuration'];
  configurationPanels: GlobalPrivateState['configurationPanels'];
  configurationId: string;
  dispatch: any;
  location: RouterState['location'];
  titles: GlobalPrivateState['titles'];
  trough: GlobalPrivateState['trough'];
}

export class ConfigurationDetail extends React.Component<ConfigurationDetailPageProps> {
  threeCanvasRef: any;

  constructor(props: ConfigurationDetailPageProps) {
    super(props);
    this.threeCanvasRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.configuration && this.props.configuration.result && this.showConfiguration) {
      this.props.dispatch(dynamicTitles.add({
        key: dynamicTitlesKey.dashboard,
        value: this.props.configuration.result.name,
      }));
    }

  }

  componentDidUpdate() {
    const { titles } = this.props;
    const configuration = this.props.configuration && this.props.configuration.result;
    const trough = this.props.trough && this.props.trough.result;

    if (configuration && this.showConfiguration) {
      if (configuration.name !== (titles.dashboard && titles.dashboard.title)) {
        this.props.dispatch(dynamicTitles.add({
          key: dynamicTitlesKey.dashboard,
          value: configuration.name,
        }));
      }
    }

    if (configuration && trough && (!this.props.plateBuilder || JSON.stringify(this.props.plateBuilder.conf.getProps) !== JSON.stringify(configuration))) {
      // We only update plateBuilder if conf changes, so better to use the confs trough than one from state
      const selectedTrough = configuration.selectedTrough && configuration.selectedTrough.trough || trough;
      this.props.dispatch(plateBuilder.clear());
      this.props.dispatch(plateBuilder.assign({configuration, trough: selectedTrough}));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('checkout'));
    this.props.dispatch(requestAPIActions.loadCleared('configuration'));
    this.props.dispatch(requestAPIActions.loadCleared('configurationDefaults'));
    this.props.dispatch(requestAPIActions.loadCleared('trough'));
    this.props.dispatch(requestAPIActions.loadCleared('troughs'));
    this.props.dispatch(validateConfiguration.clear());
    this.props.dispatch(plateBuilder.clear());
    this.props.dispatch(warnings.clear());
  }

  shouldComponentUpdate(nextProps: ConfigurationDetailPageProps) {
    const prevProps = this.props;

    const shouldUpdate: boolean[] = [];

    const configurationIdHasChanged = nextProps.configurationId !== prevProps.configurationId;

    if (configurationIdHasChanged) {
      shouldUpdate.push(true);
    } else {
      shouldUpdate.push(false);
    }

    const locationHasChanged = nextProps.location.pathname !== prevProps.location.pathname;

    if (locationHasChanged) {
      shouldUpdate.push(true);
    } else {
      shouldUpdate.push(false);
    }

    const prevName = prevProps.configuration.result && prevProps.configuration.result.name;
    const nextName = nextProps.configuration.result && nextProps.configuration.result.name;
    const nameHasChanged = prevName !== nextName;

    const prevTitle = prevProps.titles.dashboard && prevProps.titles.dashboard.title;
    const nextTitle = nextProps.titles.dashboard && nextProps.titles.dashboard.title;
    const titleHasChanged = nameHasChanged || nextTitle !== prevTitle;
    
    if (titleHasChanged) {
      shouldUpdate.push(true);
    } else {
      shouldUpdate.push(false);
    }

    const prevUpdate = prevProps.configuration.result && prevProps.configuration.result.updated_at;
    const nextUpdate = nextProps.configuration.result && nextProps.configuration.result.updated_at;
    const configurationHasChanged = prevUpdate !== nextUpdate;

    if (configurationHasChanged) {
      shouldUpdate.push(true);
    } else {
      shouldUpdate.push(false);
    }

    const prevTrough = prevProps.trough.result && prevProps.trough.result.id;
    const nextTrough = nextProps.trough.result && nextProps.trough.result.id;
    const troughHasChanged = prevTrough !== nextTrough;

    if (troughHasChanged) {
      shouldUpdate.push(true);
    } else {
      shouldUpdate.push(false);
    }

    if (prevProps.configurationPanels.isActive !== nextProps.configurationPanels.isActive) {
      shouldUpdate.push(true);
    }

    return shouldUpdate.some(should => {
      if (!should) {
        return false;
      } 
      return true;
    });
  }

  public render() {
    const { configuration, configurationId} = this.props;
    return (
      <div className="page-configuration-detail">
        <ValidationDispatcher />
        {configuration.result && (
          <TroughDispatcher />
        )}
        <ConfigurationDefaultsDispatcher id={this.props.configurationId} />

        {!configuration.result && (
          <ConfigurationDispatcher id={this.props.configurationId} />
        )}

        {this.shouldRedirect && (
          <Redirect to={`/configuration/${configurationId}/trough`} />
        )}
        
        {configuration.updating && !configuration.result && (
          <div className="loading-screen">
            <LoadingSpinner />
          </div>
        )}

        {configuration.result && (
          <>
            {this.showConfiguration ? (
              <div className="container-fluid">
                <div className="row">
                  {/* <NavbarToggler 
                    onClick={() => {this.props.dispatch(configurationPanels.toggle()); }} 
                    className={`${this.props.configurationPanels.isActive ? 'button-toggler slide-in' : 'button-toggler config-handy'}`} /> */}
                  <div className="col-8 p-0 three-js-stage">
                    {configuration.result.show2d ?
                      <SvgView />
                      :
                      <ThreeJsPartial threeCanvasRef={this.threeCanvasRef} />
                    }
                    <ConfigurationSwitchViewDetail />
                    <ConfigurationDownload3D threeCanvasRef={this.threeCanvasRef} />
                  </div>
                  <div className={`
                      col-4 
                      p-0 
                      position-absolute 
                      vh-100 
                      configuration-settings 
                      true
                      ${(this.props.configurationPanels.isActive) ? '' : 'hide-panel'}
                    `}>
                    <div className="configuration-inner">
                    <Scrollable resizeable={false}>
                      <Switch>
                        <Route 
                          exact={false}
                          path={`/configuration/${configurationId}/trough`} 
                          component={ConfigurationTroughPage}
                        />
                        <Route 
                          exact={true} 
                          path={`/configuration/${configurationId}/basin-dimensions`} 
                          component={ConfigurationBasinDimensionsPage}
                        />
                        <Route 
                          exact={true} 
                          path={`/configuration/${configurationId}/apron-backsplash`} 
                          component={ConfigurationApronBacksplashPage}
                        />
                        <Route 
                          exact={false} 
                          path={`/configuration/${configurationId}/recesses`} 
                          component={ConfigurationRecessesPage}
                        />
                        <Route 
                          exact={true} 
                          path={`/configuration/${configurationId}/surface`} 
                          component={ConfigurationSurfacePage}
                        />
                        <Route 
                          exact={true} 
                          path={`/configuration/${configurationId}/assemblies`} 
                          component={ConfigurationAssembliesPage}
                        />
                        <Route 
                          exact={true} 
                          path={`/configuration/${configurationId}/drain`} 
                          component={ConfigurationDrainsPage}
                        />
                      </Switch>
                    </Scrollable>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <Switch>
                      <Route
                        exact={true} 
                        path={`/configuration/${configurationId}/rename`} 
                        component={ConfigurationRename}
                      />
                      <Route 
                        exact={true} 
                        path={`/configuration/${configurationId}/duplicate`} 
                        component={ConfigurationDuplicate}
                      />
                      <Route
                        exact={true} 
                        path={`/configuration/${configurationId}/delete`} 
                        component={ConfigurationDelete}
                      />
                      <Route
                        exact={true} 
                        path={`/configuration/${configurationId}/archive`} 
                        component={ConfigurationArchive}
                      />
                      <Route
                        exact={true} 
                        path={`/configuration/${configurationId}/unarchive`} 
                        component={ConfigurationUnarchive}
                      />
                      <Route 
                        exact={true}
                        path={`/configuration/${configurationId}/project`} 
                        component={ConfigurationProjectPage}
                      />
                      <Route 
                        exact={true}
                        path={`/configuration/${configurationId}/country`} 
                        component={ConfigurationCountryPage}
                      />
                      <Route 
                        exact={true} 
                        path={`/configuration/${configurationId}/checkout`} 
                        render={() => <CheckoutPage configurationId={this.props.configurationId} />}
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            )}
            {/** TODO Add Configuration Breadcrumb / Navigation as Partial */}
            {this.showConfiguration && (
              <div className="fixed-bottom w-100">
                <ConfigurationNavigation />
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  private get showConfiguration(): boolean {
    const { configurationId, location } = this.props;
    return isConfigurationDetail(configurationId, location);
  }

  private get shouldRedirect(): boolean {
    let pathName = this.props.location.pathname;

    const index = pathName.lastIndexOf('/');
    if (index === pathName.length - 1) {
      pathName = pathName.substr(0, index);
    }
    
    return pathName ===  `/configuration/${this.props.configurationId}` ? true : false;
  }
}

export const ConfigurationDetailPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  configurationPanels: state.configurationPanels,
  plateBuilder: state.plateBuilder,
  location: state.router.location,
  titles: state.titles,
  trough: state.trough,
}))(ConfigurationDetail);

export default ConfigurationDetailPage;
